import artwork from "assets/megawin/design-reference.png";
import React from "react";

// The source is a design export, not individual assets. SVG viewports reuse its
// artwork without baking the screenshot's prices, game names, or controls into UI.
const PrizeArtwork = ({ section, hero = false, className }) => {
  const name = section?.section_name || section?.lottery_name || "";
  if (section?.image)
    return <img className={className} src={section.image} alt={name} />;
  let viewBox;
  if (/toyota|ra[vw]\s*4/i.test(name))
    viewBox = hero ? "575 425 780 430" : "215 1215 350 228";
  else if (/ufc/i.test(name)) viewBox = "595 1215 350 228";
  else if (/iphone\s*17/i.test(name)) viewBox = "975 1215 350 228";
  else if (/x\s*1000/i.test(name)) viewBox = "1355 1215 350 228";
  if (!viewBox)
    return (
      <div
        className={`${className || ""} mw-missing-art`}
        aria-label="Зураг байхгүй"
      >
        <span>Зураг удахгүй нэмэгдэнэ</span>
      </div>
    );
  return (
    <svg className={className} viewBox={viewBox} role="img" aria-label={name}>
      <image href={artwork} width="2913" height="4579" />
    </svg>
  );
};
export default PrizeArtwork;
